// ---------------------------------------------------------------------------
// Section 5: Fill — background color
// ---------------------------------------------------------------------------

import { InspectorSection } from '@/components/inspector'
import { InlineColorField } from '../fields'
import { extractBgColor, setBgColor } from '@/features/page-editor/lib/class-utils'
import type { CogoElement } from '@/features/page-editor/store/types'

export function FillSection({
  element,
  updateClass,
}: {
  element: CogoElement
  updateClass: (transform: (cls: string) => string) => void
}) {
  const cls = element.className ?? ''

  return (
    <InspectorSection title="Fill">
      <InlineColorField
        label="Background"
        value={extractBgColor(cls)}
        onChange={(color) => updateClass((c) => setBgColor(c, color))}
      />
    </InspectorSection>
  )
}
